<template>
    <div
        v-if="this.sentSuccessfully"
        class="alert alert-info"
        role="alert"
    >De uren zijn succesvol verstuurd. Je wordt binnen enkele seconden naar de overzichtspagina doorverwezen.</div>
    <div
        v-if="this.sentException"
        class="alert alert-info"
        role="alert"
    >Er is iets mis gegaan. De uren konden niet worden verstuurd.</div>

    <GastouderMutationOverview
        :idGastouderPeriod="idGastouderPeriod"
        :idChild="idChild"
        :showHourData="true"
        :canEdit="false"
        :idStepper="2"
        :hideEmptyDates="true"
    >
        <template v-slot:bottomButtons="{ dates }">
            <div class="row mb-3 justify-content-end">
                <div class="col-auto">
                    <router-link
                        class="btn btn-outline-info"
                        type="button"
                        :to="'/gastouder/hours-open/insert/' + idGastouderPeriod + '/' + idChild"
                    >
                        Annuleren
                    </router-link>
                    <button
                        v-if="dates !== undefined && Object.values(dates).some(date => date.agendaMutations.length > 0)"
                        id="sendButton"
                        class="btn btn-info ms-1"
                        type="button"
                        @click="sendHours()"
                    >
                        Versturen
                    </button>
                </div>
            </div>
        </template>
    </GastouderMutationOverview>
</template>

<script>
import GastouderMutationOverview from "@/views/gastouder/components/GastouderMutationOverview";
import Utils from '@/mixins/Utils.js'

export default {
    name: 'GastouderHoursInsert',
    props:  [
        'idGastouderPeriod',
        'idChild'
    ],
    mixins: [Utils],
    data () {
        return {
            sentSuccessfully: false,
            sentException: false,
        };
    },
    components: {
        GastouderMutationOverview,
    },
    methods: {
        sendHours() {
            this.scrollToTop();
            const btn = document.getElementById('sendButton');
            if (btn) {
                btn.disabled = true;
            }

            this.$request.post(
                '/gastouder-time-registration/send-hours',
                {
                    idChild: this.idChild,
                    idGastouderPeriod: this.idGastouderPeriod
                }
            )
                .then(() => {
                    this.sentSuccessfully = true;
                    this.$nextTick(() => {
                        this.scrollToTop();
                    });

                    setTimeout(() => {
                        this.$router.push('/gastouder/hours-open');
                    }, 5000);
                }).catch(() => {
                this.sentException = true;
                this.$nextTick(() => {
                    this.scrollToTop();
                });
            });
        },
    }
}

</script>